import moment from "moment";
import { api } from "../../api";
import { setCookie } from "../../utils";

export const login = async ({ username, password }, state, setState, assetId, setStart, navigate) => {
  const { data } = await api.post("authevent", JSON.stringify({ username, password, assetId })).catch((error) => error.response);

  // setStart(false);
  if (data.result) {
    const { require_quiz, examdate_at, timestart_exam, timeend_exam, timer_exam, examdate_end, slugurl, eventTime } = data.payload.event;

    const { endDate, isBetween } = eventTime;

    if (data.payload.passed) {
      navigate(`/quiz/${assetId}/complete`);
      return;
    }

    if (!require_quiz) {
      navigate(`/${assetId}/${slugurl}`);
      return;
    }

    if (endDate) {
      navigate(`/quiz/${assetId}/complete`);
      return;
    }

    if (isBetween) {
      setCookie("aphouse", data.token);
      navigate(`/login/${assetId}/condition`);
      return;
    } else {
      setStart(false);
      return;
    }

    // setCookie("aphouse", data.token);
    // navigate(`/login/${assetId}/condition`);
  } else {
    setState({
      ...state,
      error: {},
      open: false,
      errorText: { error: "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง" },
      alert: true,
    });
  }
};

export const inituser = async (assetId, slugurl, navigate) => {
  const { data } = await api.get("inituser").catch((error) => error.response);
  if (!data.result) {
    navigate(`/login/${assetId}/${slugurl}`);
  }
  if (data.payload.passed) {
    navigate(`/quiz/${assetId}/complete`);
  }
  return data;
};

export const startQuiz = async (assetId, slugurl, navigate) => {
  const { data } = await api.post("startquiz", JSON.stringify({ assetId })).catch((error) => error.response);

  if (data.result) {
    navigate(`/quiz/${assetId}/${slugurl}`);
  } else {
    navigate(`/login/${assetId}/${slugurl}`);
  }
};

export const conditionText = async (questionform_id, setCondition, state, setState) => {
  const { data } = await api.get("questiongroup/" + questionform_id).catch((error) => error.response);
  if (data.result) {
    setCondition(data.payload[0].qgroupDes);
  } else {
    setState({
      ...state,
      open: false,
      errorText: { error: "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง" },
      alert: true,
    });
  }
};
